<template>
  <div>
    <div>
      <base-title :title="StringLanguage.orders" />
    </div>

    <base-box class="box-search">
      <div class="d-flex justify-between align-center mb_5 flex-wrap">
        <div class="d-flex align-center">
          <base-label text="Buscar pedido" class="mb_0" />
          <span class="tag period" v-if="!noPeriod && !isMobile">
            {{ `Das ${formatDate(period[0])}, às ${formatDate(period[1])}` }}
            <i @click="removePeriod" class="fal fa-times remove-filter"></i>
          </span>
        </div>
        <span class="tag">
          {{`${loading ? 0 : this.countOrders.total} ocorrências`}}
        </span>

        <span class="tag period" v-if="!noPeriod && !!isMobile">
          {{ `Das ${formatDate(period[0])}, às ${formatDate(period[1])}` }}
          <i @click="removePeriod" class="fal fa-times remove-filter"></i>
        </span>
      </div>
      <base-input placeholder="Procure por cliente, telefone ou número." class="w-100 mb_0" v-model="term" search @input="isTyping = true" @keyup="loading = false" />
    </base-box>

    <!-- Labels Mobile -->
    <div class="m-show">
      <base-tabs :tabs="getTabs()" @change="setIndex" :tabActived="tabActived" class="two" />
    </div>
    <!-- fim labels mobile -->

    <!-- Kanban -->
    <div v-if="loading" class="search-loading">
      <base-loading />
    </div>
    <orders-kanban
      v-else
      @change-status="changeStatus"
      @remove-order-from-change-status="usncheduleOrderStatus"
      @open-order="openOrder"
      @simulate-order="simulateOrder"
      :orders="aOrders"
      :countByStatus="countOrders"
      :status="selectedIndex"
      :loading="loading"
      :showOrderButtonSimulator="true"
      :tabIndex="selectedIndex === 0 ? 2 : selectedIndex"
    />

    <infinite-loading v-if="!isMobile || !infiniteHandlerLimit" spinner="wavedots" @infinite="infiniteHandler" class="mt_30">
      <div slot="no-more"></div>
      <div slot="no-results">
      </div>
    </infinite-loading>

    <!-- Drawer Pedido -->
    <base-drawer
      :open="drawerDetail"
      :close="drawerDetailClose"
      :title="`${StringLanguage.order} #${ this.targetOrder.order_id }  -  ${getStatusName(targetOrder.status)}`"
      @onOpen="startDrawerTimer(targetOrder)"
      @onClose="resetTimer()"
    >
      <orders-detail
        :printers="printers"
        v-if="targetOrder.id"
        :order.sync="targetOrder"
        :catalog="catalog"
        :key="targetOrderReload"
        @change-status="changeStatus"
      />

      <template slot="footer">
        <div class="d-flex justify-between" v-if="targetOrder.id">
          <div
            class="w-100"
            v-if="
              targetOrder.delivery.type === DeliveryType.DELIVER_ON_ADDRESS &&
              targetOrder.status === Status.IN_PRODUCTION
            "
          >
            <base-button
              @click="
                drawerDetailClose =
                  true &&
                  changeStatus({
                    id: targetOrder.id,
                    status: Status.ON_DELIVERY,
                    originalStatus: targetOrder.status,
                  })
              "
              v-if="!timerId"
              :text="StringLanguage.onDelivery"
              class="w-100 big"
            />
          </div>
          <div v-else class="w-100">
            <base-button
              @click="
                drawerDetailClose =
                  true &&
                  changeStatus({
                    id: targetOrder.id,
                    status: Status.FINISHED,
                    originalStatus: targetOrder.status,
                  })
              "
              v-if="!timerId && targetOrder.status !== Status.FINISHED"
              :text="(targetOrder.status==3) ? StringLanguage.finishOrder : StringLanguage.ReadyToPickup"
              class="w-100 big"
            />
            <base-button
              v-if="targetOrder.status == 4"
              class="w-100 big"
              design="four"
              title="Imprimir 2a via"
            >
              Imprimir 2a via
            </base-button>
          </div>

          <div class="d-flex">
            <base-button @click="editOrder(targetOrder.id)" v-if="isOrderEditable()" design="four" class="ml_15" title="Editar pedido">
              <i class="fal fa-pen fs-12"></i>
            </base-button>
            <base-button v-if="targetOrder.status <= 3" design="four" class="ml_15" title="Imprimir 2a via">
              <i class="fal fa-print fs-12"></i>
            </base-button>
          </div>
        </div>
      </template>
    </base-drawer>

    <!-- Drawer Filtro -->
    <filter-period :open="drawers.filter.open" :close="drawers.filter.close" @filter="filterPeriod" :allFilter="true" :maxCustomRange="0" :defaultOption="filterType" />
  </div>
</template>
<script>

import BaseDrawer from "@/components/Drawer";
import BaseEmpty from "@/components/Empty";
import OrdersKanban from "@/containers/Orders/OrdersKanban";
import OrdersDetail from "@/containers/Orders/OrdersDetail";
import FilterPeriod from "@/containers/FilterPeriod";
import OrderAPI from "@/api/order";
import {OrderFakeApi} from "@/api/OrderFakeApi";
import StoreAPI from "@/api/store";
import CatalogAPI from "@/api/catalog";

import { mapState } from "vuex";
import { Status } from "easyjs/lib/Schema/Order";
import { DeliveryType } from "easyjs/lib/Schema/Delivery";
import Builder from "easyjs/lib/Schema/Components/Builder";

import BaseTitle from "@/components/Title";
import BaseButton from "@/components/Button";
import BaseCard from "@/components/Card";
import BaseLabel from "@/components/Label";
import BaseSelect from "@/components/Select";
import BaseBox from "@/components/Box";
import BaseTabs from "@/components/Tabs";
import BaseInput from "@/components/Input";
import BaseLoading from "@/components/Loading";

import DateTimeTools from "easyjs/lib/Tools/DateTime";

import dayjs from "dayjs";
import InfiniteLoading from "vue-infinite-loading";
import Utils from "@/utils";

export default {
  data() {
    return {
      DeliveryType,
      Status,
      search: {
        id: null,
        enabled: true,
        filter: false,
        selectedIndex: 0,
        date: DateTimeTools.subTime(new Date(), "hour", 6),
        term: null,
      },
      loading: false,
      showTags: false,
      isTyping: false,
      term: "",
      period: [new Date("2000-01-01"), new Date()],
      noPeriod: true,
      filterType: 5,
      page: 1,
      limit: 10,
      targetOrderReload: 0,
      printers: [],
      catalog: "",
      selectedIndex: 2,
      targetOrder: {},
      drawerDetail: false,
      drawerDetailClose: false,
      infiniteHandlerLimit: false,
      drawers: {
        filter: {
          open: false,
          close: false,
        },
      },
      aOrders: {
        in_production: {
          id: 2,
          name: StringLanguage.production,
          orders: [],
        },
        delivery: {
          id: 3,
          name: StringLanguage.delivery,
          orders: [],
        },
        finished: {
          id: 4,
          name: StringLanguage.finished,
          orders: [],
        },
      },
      timerId: null,
      statusChangeTimer: 0,
      originalOrders: null,
      scheduledOrders: null,
      countOrders: {
        total: 0,
        [Status.IN_PRODUCTION]: 0,
        [Status.ON_DELIVERY]: 0,
        [Status.FINISHED]: 0,
      },
    };
  },
  created() {
    return StoreAPI.storeGetConfiguration("printers", false).then((printerResponse) => {
        if (printerResponse.getErrors([]).length > 0) this.printers = [];
        else this.printers = printerResponse.getData({}).printers;
      }).then(() => {
        this.catalog = Builder.mountSchema(
            OrderFakeApi.getProductTemplate()
        );
        Builder.executeOnSchema(this.catalog, function (item) {
          item.new = false;
          item.quantity = 0;
        });
        return this;
      });
  },
  methods: {
    simulateOrder() {
      OrderFakeApi.new();
    },
    startDrawerTimer(targetOrder) {},
    drawerTimer(seconds) {},
    resetTimer() {},
    isOrderEditable() {
      return false;
    },
    addAcceptedOrder(order) {
      if (!this.term && this.noPeriod) {
        this.aOrders["in_production"].orders.unshift(order);  
        this.countOrders[Status.IN_PRODUCTION]++;
        this.countOrders.total++;
      }
    },
    updateEditedOrder(editedOrder) {},
    removeCanceledOrder(canceledOrder) {
      this.searchOrders({ term: this.drawers.filter.term });
    },
    async changeStatus(order) {
      let self = this;

      switch (order.status) {
        case Status.IN_PRODUCTION:
          OrderFakeApi.accept(order.id);
          break;
        case Status.ON_DELIVERY:
          OrderFakeApi.deliver(order.id)
          break;
        case Status.FINISHED:
          OrderFakeApi.finish(order.id)
          break;
        case Status.CANCELLED:
          OrderFakeApi.cancel(order.id)
          self.drawerDetailClose = !self.drawerDetailClose;
          break;
      }
    },
    usncheduleOrderStatus(schedule) {},
    openOrder(order) {
      this.targetOrder = order;
      this.targetOrderReload += 1;
      this.drawerDetail = !this.drawerDetail;
    },
    getTabs() {
      return Object.values(this.aOrders).map((aOrder) => {
        return {
          name: aOrder.name,
          value: aOrder.id,
          count: this.countOrders[aOrder.id] || 0,
        };
      });
    },
    setIndex(val) {
      this.selectedIndex = val;
      this.infiniteHandlerLimit = false;
    },
    editOrder(orderId) {},
    async print(trigger) {},
    filterPeriod(filter = false) {
      this.page = 1;

      if (filter) {
        this.noPeriod = false;
        this.filterType = filter.type;
        this.period[0] = new Date(filter.periods[0]);
        this.period[1] = new Date(filter.periods[1]);
      }

      this.searchOrders(this.period);
      this.drawers.filter.close = !this.drawers.filter.close;
    },
    removePeriod() {
      this.noPeriod = true;
      this.period = [new Date("1900-01-01"), new Date()];
      this.searchOrders();
    },
    formatDate(date) {
      date = dayjs(date).format("YYYY-MM-DDTHH:mm:ssZ[Z]");

      const ds = date.split("T");
      return dayjs(dayjs(`${ds[0]} ${ds[1].split("-")[0]}`)).format(
        "HH:mm [de] DD/MM/YYYY"
      );
    },
    getAll(){
      for (const i in this.aOrders) {
        this.aOrders[i].orders = (this.page == 1) ? responseData[i] : this.aOrders[i].orders.concat(responseData[i]);
      }
    },
    searchOrders(periods, scroll = false) {
      const self = this;
      
      if(this.noPeriod) {
        periods = [new Date("2000-01-01"), new Date()];
      }

      return new Promise(async (resolve) => {
        const response = await OrderFakeApi.list({ term: this.term, periods: periods || [] });
        const { in_production, delivery, finished, count } = response.getData();
        this.aOrders = {
            in_production: {
                id: 2,
                name: StringLanguage.production,
                orders: in_production,
            },
            delivery: {
                id: 3,
                name: StringLanguage.delivery,
                orders: delivery,
            },
            finished: {
                id: 4,
                name: StringLanguage.finished,
                orders: finished,
            }
        };

        this.countOrders.total = count.length;
        this.countOrders[Status.IN_PRODUCTION] = in_production.length;
        this.countOrders[Status.ON_DELIVERY] = delivery.length;
        this.countOrders[Status.FINISHED] = finished.length;
        resolve(false);
      });
    },
    changeOrderGroup(schedule, fromStatus, toStatus) {
      this.searchOrders(this.period);
    },
    getStatusName(status) {
      switch (status) {
        case Status.ON_DELIVERY:
          return StringLanguage.onDelivery;
        case Status.FINISHED:
          return StringLanguage.finished;
        default:
          return StringLanguage.inProduction;
      }
    },
    getTabKey(tabIndex) {
      switch (tabIndex) {
        case 0:
        case 2:
          return "in_production";
        case 3:
          return "delivery";
        case 4:
          return "finished";
      }
    },
    async infiniteHandler($state) {
      const result = await this.searchOrders(this.period, true);
      if (result) {
        this.page++;
        $state.loaded();
      } else {
        $state.complete();
      }
    },
  },
  components: {
    BaseDrawer,
    BaseTitle,
    BaseButton,
    BaseBox,
    BaseCard,
    BaseLabel,
    BaseSelect,
    BaseTabs,
    BaseInput,
    OrdersKanban,
    OrdersDetail,
    FilterPeriod,
    InfiniteLoading,
    BaseLoading,
    BaseEmpty,
  },
  computed: {
    tabActived() {
      return Object.values(this.aOrders)
        .map((aOrder) => aOrder.id)
        .indexOf(this.selectedIndex);
    },
    ...mapState({
      newChangeOrderStatus: (state) => state.socket.newChangeOrderStatus,
      cancelChangeOrderStatus: (state) => state.socket.cancelChangeOrderStatus,
      newAcceptedOrder: (state) => state.socket.newAcceptedOrder,
      newEditedOrder: (state) => state.socket.newEditedOrder,
      newCanceledOrder: (state) => state.socket.newCanceledOrder,
      isMobile: (state) => state.store.isMobile,
    }),
  },
  watch: {
    newChangeOrderStatus: function (schedule) {
      this.changeOrderGroup(
        schedule,
        schedule.data.originalStatus,
        schedule.data.status
      );
    },
    cancelChangeOrderStatus: function (schedule) {
      this.changeOrderGroup(
        schedule,
        schedule.data.status,
        schedule.data.originalStatus
      );
    },
    newAcceptedOrder: function (order) {
      this.addAcceptedOrder(order);
    },
    newEditedOrder: function (order) {
      this.updateEditedOrder(order);
    },
    newCanceledOrder: function (order) {
      this.removeCanceledOrder(order);
    },
    term: Utils.debounce(function () {
      this.isTyping = false;
    }, 1000),
    isTyping: function (value) {
      if (!value) {
        this.page = 1;
        this.searchOrders(this.period);
      }
    },
  },
  filters: {
    timerLabel(timer) {
      return `Desfazer (${timer}s)`;
    },
  },
};
</script>

<style scoped>
.box-search {
  margin-bottom: 55px;
}

.search-n-filter {
  transition: 0.2s all linear;
  height: 92px;
  overflow: hidden;
  padding: 0;
}
.search-n-filter.opened {
  height: 170px;
}
.search-box {
  display: flex;
  padding: 7px 20px 2px 20px !important;
}

.tag {
  background: var(--box-up);
  padding: 4px 12px;
  margin-left: 10px;
  border-radius: 5px;
  color: #aaaaaae6;
  font-size: 14px;
  line-height: 17px;
  position: relative;
}
.tag.period {
  padding-right: 30px;
}
.tags-mobile .tag {
  margin-left: 0 !important;
  margin-top: 10px;
  padding: 10px 15px;
}
.remove-filter {
  margin-left: 12px;
  font-size: 13px;
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  align-items: center;
}

.search-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}

@media screen and (max-width: 991px) {
  .search-n-filter.opened {
    height: 278px;
  }
  .tag {
    font-size: 12px;
  }
  .tag.period {
    margin-top: 15px;
    width: 100%;
    margin-left: 0;
  }
  .box-search {
    margin-bottom: 35px;
    padding: 15px;
  }
}
</style>
